export default {
  setting: [],
  booths: [],
  storeOptions: [],
  branchUserPersons: [],
  stores: [],
  boothList: [],
  preOrders: [],
  preOrderById: null,
  shopSaleFactors: [],
  userStores: [],
  salePanelGroups: [],
  orderSettlementTypes: [],
  activePosTerminals: [],
  activeBenefitCards: [],
  printLink: null,
};
